import Network from 'infrastructure/js/modules/network';

export function update(data, id) {
  return Network.put(`communicationSettings/${id}`, data);
}

export function fetchData(profileId) {
  return Network.get(`deviceAppProfile/${profileId}/communicationSettings`);
}
